module.exports = __webpack_public_path__ + "img/undraw_warning_cyit.b12dab7c.svg";